import {throwError as observableThrowError,  Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { tap, catchError } from 'rxjs/operators';
import {JsonService} from "../../services/core/json.service";
import {CustomerContactApiResources} from "./customer.contact.constants";

@Injectable({
  providedIn: 'root'
})
export class CustomerContactDataService {
  private baseURL;

  constructor(
    private http: HttpClient,
    private jsonService: JsonService,
  ) {
    this.baseURL = CustomerContactApiResources;
  }

  list(model: any = null): Observable<any> {
    const endPoint = `${this.baseURL.list}`;
    return this.http.get<any>(endPoint, {
      params:model
    })
                    .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }
  searchContact(model: any = null): Observable<any> {
    const endPoint = `${this.baseURL.search}`;
    return this.http.post<any>(endPoint,model )
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }
  create(model: any): Observable<any> {
    const endPoint = `${this.baseURL.create}`;
    return this.http.post<any>(endPoint, model)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  detail(id:any): Observable<any> {
    const endPoint = `${this.baseURL.detail}/${id}`;
    return this.http.get<any>(endPoint)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  update(id:any, model: any): Observable<any> {
    const endPoint = `${this.baseURL.update}/${id}`;
    return this.http.patch<any>(endPoint, model)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  delete(id:any): Observable<any> {
    const endPoint = `${this.baseURL.delete}/${id}`;
    return this.http.delete<any>(endPoint)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  // Bulk delete: DELETE contacts/delete/multiple with { contact_ids: [...] }
  deleteMultiple(contactIds: any[]): Observable<any> {
    const endPoint = `${this.baseURL.deleteMultiple}`;
    return this.http.request<any>('delete', endPoint, { body: { contact_ids: contactIds } })
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  // Pre-check which of the selected contacts can be deleted (and why not, for the rest)
  deleteAvailability(contactIds: any[]): Observable<any> {
    const endPoint = `${this.baseURL.deleteAvailability}`;
    return this.http.post<any>(endPoint, { contact_ids: contactIds })
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  errorHandler(error: HttpErrorResponse) {
    return observableThrowError(error.error || 'Server Error');
  }

  errorHandlerMessage(error: HttpErrorResponse) {
    return observableThrowError(error.error || 'Server Error');
  }
}
